import type { HoverCardProps as MantineHoverCardProps } from '@mantine/core';
import { HoverCard as MantineHoverCard } from '@mantine/core';

import type { LockedProps } from '../types';

export type HoverCardProps = Omit<MantineHoverCardProps, LockedProps>;

export const HoverCard = (props: HoverCardProps) => {
  return <MantineHoverCard {...props} />;
};

HoverCard.Target = MantineHoverCard.Target;
HoverCard.Dropdown = MantineHoverCard.Dropdown;
